import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faAddressBook,
  faAddressCard,
  faAt,
  faAward,
  faBan,
  faBarcode,
  faBaseballBatBall,
  faBasketball,
  faBasketShopping,
  faBell,
  faBolt,
  faBook,
  faBookOpen,
  faBox,
  faBoxArchive,
  faBriefcase,
  faBuilding,
  faBullhorn,
  faBullseye,
  faBus,
  faCalendar,
  faCalendarCheck,
  faCalendarDays,
  faCalendarWeek,
  faCamera,
  faCartShopping,
  faChair,
  faChartBar,
  faChartColumn,
  faChartLine,
  faChartPie,
  faChild,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faClipboard,
  faClipboardList,
  faClock,
  faCloud,
  faCloudArrowUp,
  faCode,
  faCodeBranch,
  faCoins,
  faComment,
  faComments,
  faCommentSms,
  faCompass,
  faCreditCard,
  faCrown,
  faCubes,
  faDatabase,
  faDiagramProject,
  faDollarSign,
  faDoorOpen,
  faDownload,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopesBulk,
  faEuroSign,
  faEye,
  faFile,
  faFileExport,
  faFileImport,
  faFileLines,
  faFilter,
  faFire,
  faFlag,
  faFlagCheckered,
  faFolder,
  faFolderOpen,
  faFootball,
  faFutbol,
  faGauge,
  faGear,
  faGears,
  faGift,
  faGlobe,
  faGolfBallTee,
  faGraduationCap,
  faHandHoldingDollar,
  faHandHoldingHeart,
  faHandshake,
  faHashtag,
  faHeart,
  faHockeyPuck,
  faHourglassHalf,
  faHouse,
  faIdBadge,
  faIdCard,
  faImage,
  faInbox,
  faKey,
  faLandmark,
  faLayerGroup,
  faLightbulb,
  faLink,
  faList,
  faListCheck,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMap,
  faMapLocationDot,
  faMedal,
  faMessage,
  faMobileScreen,
  faMoneyBill,
  faMusic,
  faNewspaper,
  faPalette,
  faPaperPlane,
  faPen,
  faPenToSquare,
  faPeopleGroup,
  faPercent,
  faPersonRunning,
  faPhone,
  faPlane,
  faPlug,
  faPrint,
  faPuzzlePiece,
  faQrcode,
  faRankingStar,
  faReceipt,
  faRobot,
  faRocket,
  faRoute,
  faRss,
  faScaleBalanced,
  faScrewdriverWrench,
  faServer,
  faShareNodes,
  faShieldHalved,
  faSitemap,
  faSliders,
  faSquareParking,
  faStar,
  faSterlingSign,
  faStopwatch,
  faStore,
  faTable,
  faTableList,
  faTableTennisPaddleBall,
  faTag,
  faTags,
  faThumbsUp,
  faTicket,
  faTicketSimple,
  faToolbox,
  faTriangleExclamation,
  faTrophy,
  faTruck,
  faUpload,
  faUser,
  faUserGroup,
  faUserPlus,
  faUsers,
  faUserShield,
  faUserTie,
  faVideo,
  faVolleyball,
  faWallet,
  faWandMagicSparkles,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";

// A curated set, so the sidebar can draw any of them without the whole icon pack.
const icons: IconDefinition[] = [
  faAddressBook,
  faAddressCard,
  faAt,
  faAward,
  faBan,
  faBarcode,
  faBaseballBatBall,
  faBasketball,
  faBasketShopping,
  faBell,
  faBolt,
  faBook,
  faBookOpen,
  faBox,
  faBoxArchive,
  faBriefcase,
  faBuilding,
  faBullhorn,
  faBullseye,
  faBus,
  faCalendar,
  faCalendarCheck,
  faCalendarDays,
  faCalendarWeek,
  faCamera,
  faCartShopping,
  faChair,
  faChartBar,
  faChartColumn,
  faChartLine,
  faChartPie,
  faChild,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faClipboard,
  faClipboardList,
  faClock,
  faCloud,
  faCloudArrowUp,
  faCode,
  faCodeBranch,
  faCoins,
  faComment,
  faComments,
  faCommentSms,
  faCompass,
  faCreditCard,
  faCrown,
  faCubes,
  faDatabase,
  faDiagramProject,
  faDollarSign,
  faDoorOpen,
  faDownload,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopesBulk,
  faEuroSign,
  faEye,
  faFile,
  faFileExport,
  faFileImport,
  faFileLines,
  faFilter,
  faFire,
  faFlag,
  faFlagCheckered,
  faFolder,
  faFolderOpen,
  faFootball,
  faFutbol,
  faGauge,
  faGear,
  faGears,
  faGift,
  faGlobe,
  faGolfBallTee,
  faGraduationCap,
  faHandHoldingDollar,
  faHandHoldingHeart,
  faHandshake,
  faHashtag,
  faHeart,
  faHockeyPuck,
  faHourglassHalf,
  faHouse,
  faIdBadge,
  faIdCard,
  faImage,
  faInbox,
  faKey,
  faLandmark,
  faLayerGroup,
  faLightbulb,
  faLink,
  faList,
  faListCheck,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMap,
  faMapLocationDot,
  faMedal,
  faMessage,
  faMobileScreen,
  faMoneyBill,
  faMusic,
  faNewspaper,
  faPalette,
  faPaperPlane,
  faPen,
  faPenToSquare,
  faPeopleGroup,
  faPercent,
  faPersonRunning,
  faPhone,
  faPlane,
  faPlug,
  faPrint,
  faPuzzlePiece,
  faQrcode,
  faRankingStar,
  faReceipt,
  faRobot,
  faRocket,
  faRoute,
  faRss,
  faScaleBalanced,
  faScrewdriverWrench,
  faServer,
  faShareNodes,
  faShieldHalved,
  faSitemap,
  faSliders,
  faSquareParking,
  faStar,
  faSterlingSign,
  faStopwatch,
  faStore,
  faTable,
  faTableList,
  faTableTennisPaddleBall,
  faTag,
  faTags,
  faThumbsUp,
  faTicket,
  faTicketSimple,
  faToolbox,
  faTriangleExclamation,
  faTrophy,
  faTruck,
  faUpload,
  faUser,
  faUserGroup,
  faUserPlus,
  faUsers,
  faUserShield,
  faUserTie,
  faVideo,
  faVolleyball,
  faWallet,
  faWandMagicSparkles,
  faWarehouse,
];

/** The icons a section or page can take, by their Font Awesome name, e.g. "envelope". */
export const sitemapIcons: Record<string, IconDefinition> = Object.fromEntries(
  icons.map((icon) => [icon.iconName, icon])
);

export const sitemapIconNames = Object.keys(sitemapIcons).sort();

/** The icon saved on a section or page, or undefined when it has none we know. */
export const getSitemapIcon = (name: string | null | undefined) =>
  name ? sitemapIcons[name] : undefined;
